// This file is autogenerated. Any changes will be overwritten.

export const set = 'streamline';

export const name = 'grid-solid';

export const Component = () => (
  <path
    fill='currentColor'
    stroke='currentColor'
    strokeLinecap='round'
    strokeLinejoin='round'
    d='M1.465 4h3.133s.433 0 .433.433v3.134s0 .433-.433.433H1.465s-.434 0-.434-.433V4.433s0-.433.434-.433zm11.968 0h3.134S17 4 17 4.433v3.134S17 8 16.567 8h-3.134S13 8 13 7.567V4.433S13 4 13.433 4zM7.465 4h3.133s.433 0 .433.433v3.134s0 .433-.433.433H7.465s-.434 0-.434-.433V4.433s0-.433.434-.433zm-6 6h3.133s.433 0 .433.433v3.134s0 .433-.433.433H1.465s-.434 0-.434-.433v-3.134s0-.433.434-.433zm6 0h3.133s.433 0 .433.433v3.134s0 .433-.433.433H7.465s-.434 0-.434-.433v-3.134s0-.433.434-.433zm5.968 0h3.134s.433 0 .433.433v3.134s0 .433-.433.433h-3.134S13 14 13 13.567v-3.134s0-.433.433-.433z'
  />
);

export const viewBox = '0 0 18 18';
